import { inject, injectable } from 'inversify';
import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';
import type JsonRpcDispatcher from '@dealroadshow/json-rpc-dispatcher';
import Request from '@framework/api/Rpc/Request';
import AskAiDITypes from '@creditflowresearch/socket-client/socket-ask-ai-client/DITypes';
import {
  IAskAiLlmModel,
  IAskAiLlmOperationParams,
  IAskAiLlmSettingsEntry,
} from '@/creditflowresearch/domain/vo/AskAiLlmSettings';

@injectable()
class AskAiLlmSettingsRepository {
  constructor(@inject(AskAiDITypes.JsonRpcDispatcher) private readonly rpc: JsonRpcDispatcher) {}

  getModels = async (): Promise<IAskAiLlmModel[]> => {
    const request = new Request('cfr.ask_ai.models_list', {});
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().items;
  };

  getSettings = async (): Promise<IAskAiLlmSettingsEntry[]> => {
    const request = new Request('cfr.ask_ai.get_llm_settings', {});
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().items;
  };

  saveSettings = async (settings: IAskAiLlmOperationParams[]): Promise<string | null> => {
    const request = new Request('cfr.ask_ai.save_llm_settings', { settings });
    const response = await this.rpc.call<RpcSuccess>(request);
    const { error } = response.getResult();

    return typeof error === 'string' ? error : null;
  };
}

export default AskAiLlmSettingsRepository;
